import request from '@/utils/request'

let VisionApi = {
  /*获取数据*/
  getData(data, errorback) {
    return request._get('/shop/plus.vision.vision/index', data, errorback);
  },


  /*视力数据列表*/
  /*用户拍卖列表*/
  getVisionList(data, errorback) {
    return request._post('/shop/plus.vision.vision/index', data, errorback);
  },
  /* 省列表 */
  provinceList(data, errorback) {
    return request._get('/shop/plus.vision.vision/provinceList', data, errorback);
  },
  /* 市列表 */
  city_list(data, errorback) {
    return request._get('/shop/plus.vision.vision/cityList', data, errorback);
  },
  /* 区域列表 */
  region_list(data, errorback) {
    return request._get('/shop/plus.vision.vision/regionList', data, errorback);
  },

  /*获取视力数据信息*/
  visionDetail(data, errorback) {
    return request._post('/shop/plus.vision.vision/visionDetail', data, errorback);
  },
  /*修改视力数据*/
  editVision(data, errorback) {
    return request._post('/shop/plus.vision.vision/edit', data, errorback);
  },
  /*删除视力数据*/
  deleteVision(data, errorback) {
    return request._post('/shop/plus.vision.vision/delete', data, errorback);
  },

  /*管理员列表*/
  userList(data, errorback) {
    return request._post('/shop/plus.vision.manager/index', data, errorback);
  },
  /*添加管理员需要的数据*/
  userAddInfo(data, errorback) {
    return request._post('/shop/plus.vision.manager/addInfo', data, errorback);
  },
  /*添加管理员*/
  userAdd(data, errorback) {
    return request._post('/shop/plus.vision.manager/add', data, errorback);
  },
  /*修改管理员需要的数据*/
  userEditInfo(data, errorback) {
    return request._get('/shop/plus.vision.manager/edit', data, errorback);
  },
  /*修改管理员*/
  userEdit(data, errorback) {
    return request._post('/shop/plus.vision.manager/edit', data, errorback);
  },
  /*删除管理员*/
  userDelete(data, errorback) {
    return request._post('/shop/plus.vision.manager/delete', data, errorback);
  },
  /*删除管理员*/
  auth(data, errorback) {
    return request._post('/shop/plus.vision.vision/auth', data, errorback);
  },


}
export default VisionApi;



// WEBPACK FOOTER //
// ./src/api/vision.js